import React from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

const ProductTypeTabs = ({ value, onChange, disabled, getOptions }) => {
  const theme = useTheme();
  const options = getOptions();

  return (
    <>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}
      >
        Product Type
      </Typography>
      <Tabs
        value={value}
        onChange={(e, newValue) => onChange(newValue)}
        variant="fullWidth"
        sx={{
          "& .MuiTabs-flexContainer": {
            backgroundColor: alpha(theme.palette.primary.main, 0.1),
            borderRadius: 3,
            p: 0.25,
          },
          "& .MuiTabs-indicator": { display: "none" },
        }}
      >
        {options.map((option) => (
          <Tab
            key={option}
            value={option}
            disableRipple
            disabled={disabled}
            sx={{
              borderRadius: 2,
              fontSize: "0.7rem",
              minHeight: 32,
              height: 32,
              padding: "4px 8px",
              color:
                value === option
                  ? "#FFFFFF !important"
                  : theme.palette.text.primary,
              backgroundColor:
                value === option
                  ? (() => {
                      switch (option) {
                        case "MIS":
                          return theme.palette.success.main;
                        case "CNC":
                          return theme.palette.success.dark;
                        case "NRML":
                          return theme.palette.success.main;
                        default:
                          return theme.palette.success.main;
                      }
                    })()
                  : "transparent",
              "&:hover": {
                backgroundColor:
                  value === option
                    ? (() => {
                        switch (option) {
                          case "MIS":
                            return theme.palette.success.main;
                          case "CNC":
                            return theme.palette.success.dark;
                          case "NRML":
                            return theme.palette.success.main;
                          default:
                            return theme.palette.success.main;
                        }
                      })()
                    : alpha(theme.palette.primary.main, 0.2),
                color: "#FFFFFF !important",
              },
            }}
            label={(() => {
              if (option === "MIS") return "Intraday";
              if (option === "CNC" || option === "NRML") return "Overnight";
              return option;
            })()}
          />
        ))}
      </Tabs>
    </>
  );
};

export default ProductTypeTabs;


